import { EventEmitter, Component, Input, Output, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { InlineSVGModule } from 'ng-inline-svg';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';

import * as ɵngcc0 from '@angular/core';
import * as ɵngcc1 from '@angular/common';
import * as ɵngcc2 from '@ng-bootstrap/ng-bootstrap';
import * as ɵngcc3 from 'ng-inline-svg';

function FilterByComponent_div_1_button_13_Template(rf, ctx) { if (rf & 1) {
    const _r4 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "button", 7);
    ɵngcc0.ɵɵlistener("click", function FilterByComponent_div_1_button_13_Template_button_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r4); const option_r2 = ctx.$implicit; const ctx_r3 = ɵngcc0.ɵɵnextContext(2); return ctx_r3.filterByProperty(option_r2); });
    ɵngcc0.ɵɵelementStart(1, "div", 8);
    ɵngcc0.ɵɵelementStart(2, "div", 9);
    ɵngcc0.ɵɵelement(3, "input", 13);
    ɵngcc0.ɵɵelementStart(4, "label", 14);
    ɵngcc0.ɵɵtext(5);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const option_r2 = ctx.$implicit;
    const ctx_r1 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵattribute("aria-checked", ctx_r1.selectedOption == option_r2);
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵpropertyInterpolate("id", option_r2);
    ɵngcc0.ɵɵpropertyInterpolate("value", option_r2);
    ɵngcc0.ɵɵproperty("checked", ctx_r1.selectedOption == option_r2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵpropertyInterpolate("for", option_r2);
    ɵngcc0.ɵɵproperty("ngClass", ctx_r1.selectedOption == option_r2 ? "text-primary font-weight-bold" : "font-weight-normal");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(option_r2);
} }
function FilterByComponent_div_1_Template(rf, ctx) { if (rf & 1) {
    const _r6 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 1);
    ɵngcc0.ɵɵelementStart(1, "button", 2);
    ɵngcc0.ɵɵelement(2, "span", 3);
    ɵngcc0.ɵɵelementStart(3, "label", 4);
    ɵngcc0.ɵɵtext(4, "Filter");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(5, "div", 5);
    ɵngcc0.ɵɵelementStart(6, "div", 6);
    ɵngcc0.ɵɵelementStart(7, "button", 7);
    ɵngcc0.ɵɵlistener("click", function FilterByComponent_div_1_Template_button_click_7_listener() { ɵngcc0.ɵɵrestoreView(_r6); const ctx_r5 = ɵngcc0.ɵɵnextContext(); return ctx_r5.resetFilter(); });
    ɵngcc0.ɵɵelementStart(8, "div", 8);
    ɵngcc0.ɵɵelementStart(9, "div", 9);
    ɵngcc0.ɵɵelement(10, "input", 10);
    ɵngcc0.ɵɵelementStart(11, "label", 11);
    ɵngcc0.ɵɵtext(12, "All");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(13, FilterByComponent_div_1_button_13_Template, 6, 7, "button", 12);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("autoClose", true);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("inlineSVG", "assets/images/icons/filter.svg");
    ɵngcc0.ɵɵadvance(5);
    ɵngcc0.ɵɵattribute("aria-checked", ctx_r0.selectedOption == undefined);
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵproperty("checked", ctx_r0.selectedOption == undefined);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngClass", ctx_r0.selectedOption == undefined ? "text-primary font-weight-bold" : "font-weight-normal");
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r0.filterOptions.options);
} }
class FilterByComponent {
    constructor() {
        this.filteredArray = new EventEmitter();
    }
    ngOnInit() { }
    /*
     Filter the array by property or sub-property if defined.
    */
    filterByProperty(value) {
        this.selectedOption = value;
        let newArray;
        if (this.filterOptions.subPropertyToFilter) {
            newArray = this.filterByNestedProperty(value);
        }
        else {
            newArray = this.arrayToFilter.filter((item) => item[this.filterOptions.propertyToFilter].toLowerCase() == value.toLowerCase());
        }
        this.filteredArray.emit(newArray);
    }
    /*
     Filter the array by sub-property from property object. Returns false if the expected property object is empty.
    */
    filterByNestedProperty(value) {
        return this.arrayToFilter.filter((properties) => {
            if (properties[this.filterOptions.propertyToFilter]) {
                return properties[this.filterOptions.propertyToFilter].find((child) => child[this.filterOptions.subPropertyToFilter].toLowerCase() == value.toLowerCase());
            }
            else {
                return false;
            }
        });
    }
    /*
     Resets the filter to the original array
    */
    resetFilter() {
        this.selectedOption = undefined;
        this.filteredArray.emit(this.arrayToFilter);
    }
}
FilterByComponent.ɵfac = function FilterByComponent_Factory(t) { return new (t || FilterByComponent)(); };
FilterByComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: FilterByComponent, selectors: [["fgbcl-filter-by"]], inputs: { arrayToFilter: "arrayToFilter", filterOptions: "filterOptions" }, outputs: { filteredArray: "filteredArray" }, decls: 2, vars: 1, consts: [["ngbDropdown", "", "class", "d-flex filter-by", "role", "group", 3, "autoClose", 4, "ngIf"], ["ngbDropdown", "", "role", "group", 1, "d-flex", "filter-by", 3, "autoClose"], ["id", "dropdownMenuButton", "type", "button", "ngbDropdownToggle", "", 1, "tool-bar__option", "btn", "dropdown-toggle", "w-100"], [1, "svg", "filter", "my-0", 3, "inlineSVG"], [1, "font-size-14", "mb-0"], ["ngbDropdownMenu", "", "aria-labelledby", "dropdownMenuButton", 1, "col-12", "shadow", "dropdown-menu-right", "filter-dropdown", "mt-2"], [1, "d-flex", "flex-column"], ["type", "button", "role", "radio", 1, "filter-bar-item", "filter-item", "text-black", "bg-white", "py-0", "font-size-12", "rounded", 3, "click"], [1, "w-100", "h-100"], [1, "radio-item", "d-flex", "align-items-center", "px-2"], ["type", "radio", "name", "filterBy", "id", "undefinedOption", "value", "undefined", 1, "mr-3", 3, "checked"], ["for", "undefinedOption", 1, "mb-0", "font-size-14", 3, "ngClass"], ["type", "button", "role", "radio", "class", "filter-bar-item filter-item text-black bg-white py-0 font-size-12 rounded", 3, "click", 4, "ngFor", "ngForOf"], ["type", "radio", "name", "filterBy", 1, "mr-3", 3, "id", "value", "checked"], [1, "mb-0", "font-size-14", 3, "for", "ngClass"]], template: function FilterByComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "form");
        ɵngcc0.ɵɵtemplate(1, FilterByComponent_div_1_Template, 14, 6, "div", 0);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.filterOptions);
    } }, directives: [ɵngcc1.NgIf, ɵngcc2.NgbDropdown, ɵngcc2.NgbDropdownToggle, ɵngcc3.InlineSVGDirective, ɵngcc2.NgbDropdownMenu, ɵngcc1.NgClass, ɵngcc1.NgForOf], styles: [""] });
FilterByComponent.ctorParameters = () => [];
FilterByComponent.propDecorators = {
    arrayToFilter: [{ type: Input }],
    filterOptions: [{ type: Input }],
    filteredArray: [{ type: Output }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(FilterByComponent, [{
        type: Component,
        args: [{
                selector: 'fgbcl-filter-by',
                template: "<form>\r\n  <div ngbDropdown class=\"d-flex filter-by\" [autoClose]=\"true\" role=\"group\" *ngIf=\"filterOptions\">\r\n    <button id=\"dropdownMenuButton\" class=\"tool-bar__option btn dropdown-toggle w-100\" type=\"button\" ngbDropdownToggle>\r\n      <span class=\"svg filter my-0\" [inlineSVG]=\"'assets/images/icons/filter.svg'\"></span>\r\n      <label class=\"font-size-14 mb-0\">Filter</label>\r\n    </button>\r\n    <div ngbDropdownMenu aria-labelledby=\"dropdownMenuButton\" class=\"col-12 shadow dropdown-menu-right filter-dropdown mt-2\">\r\n      <div class=\"d-flex flex-column\">\r\n        <button\r\n          type=\"button\"\r\n          class=\"filter-bar-item filter-item text-black bg-white py-0 font-size-12 rounded\"\r\n          role=\"radio\"\r\n          [attr.aria-checked]=\"selectedOption == undefined\"\r\n          (click)=\"resetFilter()\"\r\n        >\r\n          <div class=\"w-100 h-100\">\r\n            <div class=\"radio-item d-flex align-items-center px-2\">\r\n              <input\r\n                type=\"radio\"\r\n                name=\"filterBy\"\r\n                id=\"undefinedOption\"\r\n                value=\"undefined\"\r\n                class=\"mr-3\"\r\n                [checked]=\"selectedOption == undefined\"\r\n              />\r\n              <label\r\n                for=\"undefinedOption\"\r\n                class=\"mb-0 font-size-14\"\r\n                [ngClass]=\"selectedOption == undefined ? 'text-primary font-weight-bold' : 'font-weight-normal'\"\r\n                >All</label\r\n              >\r\n            </div>\r\n          </div>\r\n        </button>\r\n        <button\r\n          type=\"button\"\r\n          *ngFor=\"let option of filterOptions.options\"\r\n          role=\"radio\"\r\n          [attr.aria-checked]=\"selectedOption == option\"\r\n          (click)=\"filterByProperty(option)\"\r\n          class=\"filter-bar-item filter-item text-black bg-white py-0 font-size-12 rounded\"\r\n        >\r\n          <div class=\"w-100 h-100\">\r\n            <div class=\"radio-item d-flex align-items-center px-2\">\r\n              <input\r\n                type=\"radio\"\r\n                name=\"filterBy\"\r\n                id=\"{{ option }}\"\r\n                value=\"{{ option }}\"\r\n                class=\"mr-3\"\r\n                [checked]=\"selectedOption == option\"\r\n              />\r\n              <label\r\n                for=\"{{ option }}\"\r\n                class=\"mb-0 font-size-14\"\r\n                [ngClass]=\"selectedOption == option ? 'text-primary font-weight-bold' : 'font-weight-normal'\"\r\n                >{{ option }}</label\r\n              >\r\n            </div>\r\n          </div>\r\n        </button>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</form>\r\n",
                styles: [""]
            }]
    }], function () { return []; }, { filteredArray: [{
            type: Output
        }], arrayToFilter: [{
            type: Input
        }], filterOptions: [{
            type: Input
        }] }); })();

class FilterByModule {
}
FilterByModule.ɵfac = function FilterByModule_Factory(t) { return new (t || FilterByModule)(); };
FilterByModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: FilterByModule });
FilterByModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ imports: [[CommonModule, InlineSVGModule, NgbModule]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(FilterByModule, { declarations: function () { return [FilterByComponent]; }, imports: function () { return [CommonModule, InlineSVGModule, NgbModule]; }, exports: function () { return [FilterByComponent]; } }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(FilterByModule, [{
        type: NgModule,
        args: [{
                declarations: [FilterByComponent],
                imports: [CommonModule, InlineSVGModule, NgbModule],
                exports: [FilterByComponent]
            }]
    }], null, null); })();

const filterByOptionMock = {
    propertyToFilter: 'category',
    options: ['Beauty', 'Food & Drink', 'Grocery', 'General', 'Travel'],
};

/**
 * Generated bundle index. Do not edit.
 */

export { FilterByComponent, FilterByModule, filterByOptionMock };

//# sourceMappingURL=fgb-portal-component-library-src-lib-shared-filter-by.js.map